import { Form } from 'antd'
import { FormItemProps } from 'antd/lib/form'
import dayjs from 'dayjs'

import { yearMonthDaySlash } from 'src/libs'

import { Paragraph } from '../Typography'

type DummyProps = {
  value?: FormItemProps['valuePropName']
}

type Props = {
  isEditing: boolean
} & FormItemProps

export const EditableFormItem = ({ isEditing, ...rest }: Props) => {
  return (
    <Form.Item {...rest}>{isEditing ? rest.children : <Dummy />}</Form.Item>
  )
}

const Dummy = ({ value }: DummyProps) => {
  // A dayjs value (even an invalid one, e.g. dayjs(null)) must never be
  // rendered as a React child.
  const formattedValue = dayjs.isDayjs(value)
    ? value.isValid()
      ? value.format(yearMonthDaySlash)
      : '-'
    : dayjs(value, '', true).isValid()
      ? dayjs(value).format(yearMonthDaySlash)
      : value

  return (
    <Paragraph ellipsis={{ rows: 1, tooltip: formattedValue }}>
      {formattedValue}
    </Paragraph>
  )
}
